import axios from "axios";
import { domain } from "../../Links/Links";

export async function hashtagsRequest(setData) {
    const response = await axios.get(domain + '/hashtags/', {
        withCredentials: true,
    })

    if (response.data) {
        setData(response.data)
    }
}